import React from "react";
import { Container, Grid, Paper, Typography } from "@mui/material";
import { Email, Instagram } from "@mui/icons-material";
import QueryForm from "./QueryForm";
import Map from "./Map";
import { Link } from "react-router-dom";

const ContactUs = () => {
  const iconStyle = {
    marginRight: "8px",
  };
  return (
    <div className="my-5">
      <Container>
        <Grid container spacing={4}>
          <Grid item md={6}>
            <div style={{ background: "#f5f5f5" }}>
              <Map />
            </div>
            <div className="d-flex mt-3 justify-content-between">
              <Link
                to="https://www.instagram.com/ooklass.in/"
                target="blank"
                className="text-decoration-none d-flex align-items-center blue-text footer-link"
              >
                <Instagram  style={iconStyle} /> Follow Us on Instagram
              </Link>
              <Link
                to="mailto:admin@ooklass.in"
                className="text-decoration-none d-flex align-items-center blue-text footer-link"
               
              >
                <Email  style={iconStyle}/> Write to Us on Email
              </Link>
            </div>
          </Grid>
          <Grid item md={6}>
            <Paper elevation={3} className="p-4">
              <Typography variant="h6" mb={2}>
                Have any Query?
              </Typography>
              {/* Include the QueryForm component here */}
              <QueryForm />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default ContactUs;
